import { createFileRoute } from "@tanstack/react-router"

import BlogsListPage from "@/features/static/components/blogs/list"

export const Route = createFileRoute("/_screen/blog/")({
  component: BlogListPage
})

function BlogListPage() {
  return <BlogsListPage />
}
